import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  current: {
    description: 'Button text for the current subscription',
    defaultMessage: 'Current',
    id: 'w5a3nV',
  },
  select: {
    description: 'Button text for a subscription that is available to select',
    defaultMessage: 'Select',
    id: '8ESivn',
  },
  deselect: {
    defaultMessage: 'Deselect',
    description: 'Text for a button to deselect the currently selected subscription',
    id: 'fmySoB',
  },
  selected: {
    defaultMessage: 'Selected',
    description: 'Text for a button to show selected subscription',
    id: '6cttJ4',
  },
});
